import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Name = styled.div`
  align-self: self-end;
  color: ${colors.titleStrongWhite};
`

export const Container = styled(Name)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  border-radius: 50%;
  background-color: ${colors.primary};
  height: 76px;
  width: 76px;

  color: ${colors.white};
  font-size: 26px;
  margin: 12px 24px;
  cursor: pointer;

  @media (max-width: 940px) {
    height: 60px;
    width: 60px;
    font-size: 20px;
    margin: 24px 24px;
  }
`

export const EditButton = styled.div`
  position: absolute;
  bottom: 2px;
  right: 0;
  height: 22px;
  width: 22px;
  padding: 3px;


  background: ${colors.titleStrongWhite};
  color: ${colors.strongGray};
  border: 1px solid ${colors.softGray};
  border-radius: 50%;

  @media (max-width: 940px) {
    padding: 1px;
  }
`
